<section class="gallery" [id]="gallerydata.id">

  <div class="container">

    <!-- ========================================
         SECTION HEADER
    ======================================== -->

    <div class="section-header">

      <span class="subtitle">
        {{ gallerydata.subtitle }}
      </span>

      <h2>
        {{ gallerydata.title }}
      </h2>

    </div>

<!-- ========================================
         Gallery
    ======================================== -->

    <div class="gallery-hero">
      <div class="thumb-strip">
        @for (item of imageData; track item.srcUrl; let i = $index) {
          <button type="button" class="thumb" [class.active]="i === selectedIndex" (click)="select(i)" [attr.aria-label]="item.alt">
            <img [src]="item.previewUrl" [alt]="item.alt" loading="lazy" />
            @if (isVideo(item.srcUrl)) {
              <span class="video-play-icon small"><i class="fa-solid fa-play"></i></span>
            }
          </button>
        }
      </div>

      <div class="hero-frame">
        <button type="button" class="hero-image" (click)="open(selectedIndex)" [attr.aria-label]="imageData[selectedIndex].alt">
          <img [src]="imageData[selectedIndex].previewUrl" [alt]="imageData[selectedIndex].alt" />
          @if (isVideo(imageData[selectedIndex].srcUrl)) {
            <span class="video-play-icon"><i class="fa-solid fa-play"></i></span>
          }
        </button>

        @if (imageData.length > 1) {
          <button type="button" class="nav-arrow prev" (click)="prev()" aria-label="Previous image">
            <i class="fa-solid fa-chevron-left"></i>
          </button>
          <button type="button" class="nav-arrow next" (click)="next()" aria-label="Next image">
            <i class="fa-solid fa-chevron-right"></i>
          </button>
        }

        <button type="button" class="view-all-btn" (click)="open(selectedIndex)">
          <i class="fa-solid fa-expand"></i> View All
        </button>
      </div>
    </div>
  </div>

</section>
